import {
  EVENT_GET_LIST,
  EVENT_REQUEST,
  EVENT_SUCCESS,
  EVENT_FAILURE,
  ONE_TOUCH_COUPON,
  FETCH_EVENT_POINT_RANK,
  FETCH_EVENT_POINT_UNIVERSITY,
  SET_RANK_LIST,
  SET_USER_UNIV_INFO,
  CLAIM_CONTENT,
  PREPARE_CLAIM_CODE,
  CLEAR_CLAIM_CODE,
  PREPARE_CLAIM_TYPE,
  CLEAR_CLAIM_TYPE
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  beforeRouteName: '',
  events: null,
  isLoading: false,
  error: null,
  meta: {},
  isTopBanner: true,
  publishList: [],
  publishInfo: {},
  publishSearch: '',
  unicolsList: [],
  unicolsInfo: {},
  unicolsSearch: '',
  publishList4Pages: [],
  eventRankList: [],
  eventUserUnivInfo: {},
  departmentsList: [],
  preparedClaimCode: null,
  preparedClaimType: null
}

const getters = {
  getBeforeRouteName: (state) => state.beforeRouteName,
  getEvents: (state) => state.events,
  isEventLoading: (state) => state.isLoading,
  getEventTotalCount: (state) =>
    state.meta.totalCount || (state.events ? state.events.length : 0),
  isShowLineBanner: (state) => state.isTopBanner,
  getPublishList: (state) => state.publishList,
  getPublishInfo: (state) => state.publishInfo,
  getPublishSearch: (state) => state.publishSearch,
  getUnicolsList: (state) => state.unicolsList,
  getUnicolsInfo: (state) => state.unicolsInfo,
  getUnicolsSearch: (state) => state.unicolsSearch,
  getPublishListForPages: (state) => state.publishList4Pages,
  getEventRanklist: (state) => state.eventRankList,
  getEventUserUnivInfo: (state) => state.eventUserUnivInfo,
  getDepartmentsList: (state) => state.departmentsList,
  getPreparedClaimCode: (state) => state.preparedClaimCode,
  getPreparedClaimType: (state) => state.preparedClaimType
}

const actions = {
  requestPresentBook(_, payload) {
    // commit('')
    return new Promise((resolve, reject) => {
      const {
        classNm,
        semester,
        textbookNm,
        publisherNm,
        couponNo,
        division,
        enrolledCount,
        remark,
        unicolCd
      } = payload
      axios
        .put('/purchase/coupon/order', {
          purchase: {
            orders: {
              purchaseTp: 'PRS',
              coupon: {
                classNm,
                semester,
                textbookNm,
                publisherNm,
                couponNo,
                division,
                unicolCd,
                enrolledCount,
                remark
              }
            }
          }
        })
        .then(resolve)
        .catch(reject)
    })
  },
  fetchUnicolsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { pageNo, pageRow, searchNm } = payload
      axios
        .get('/customer/unicols/list', {
          params: {
            pageNo,
            pageRow,
            searchNm
          }
        })
        .then((res) => {
          commit('fetchUnicols', {
            page: res.data.page,
            list:
              res.data.result?.universities || res.data.result?.schools || [],
            search: res.data.search?.searchNm
          })
          // commit('fetchUnicolsList', res.data.result.schools)
          resolve(res.data.result?.schools || [])
        })
        .catch(reject)
    })
  },
  fetchPublishList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { pageNo, pageRow, searchNm, searchTp, searchCd } = payload
      axios
        .get('/customer/publisher/list', {
          params: {
            pageNo,
            pageRow,
            searchNm,
            searchTp,
            searchCd
          }
        })
        .then((res) => {
          commit('fetchPublish', {
            page: res.data.page,
            list: res.data.result?.publishers || [],
            search: res.data.search.searchNm
          })
          // commit('fetchPublishPageInfo', res.data.page)
          // if (res.data.result !== null) {
          //   commit('fetchPublishList', res.data.result?.publishers)
          // } else {
          //   commit('fetchPublishList', [])
          // }
          resolve(res.data.result?.publishers || [])
        })
        .catch(reject)
    })
  },
  fetchDepartmentsByUniversity({ commit }, { univCode, searchKeyword }) {
    return new Promise((resolve) => {
      axios
        .get(`/universities/${univCode}/departments`, {
          params: { searchKeyword: searchKeyword }
        })
        .then((resp) => {
          commit('fetchDepartments', resp.data.result.departments)
          resolve(resp)
        })
        .catch(() => {
          commit('resetDepartments')
          // reject(err)
        })
    })
  },
  closeTopBanner({ commit }) {
    commit('closeTopBanner')
  },
  requestGifte: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(EVENT_REQUEST)

      axios
        .put('/purchase/coupon/order', {
          purchase: {
            orders: {
              purchaseTp: payload.purchaseTp ? payload.purchaseTp : '',
              coupon: {
                couponNo: payload.couponNo
              }
            }
          }
        })
        .then((resp) => {
          resolve(resp)
        })
        .catch((err) => {
          commit(EVENT_FAILURE, err)
          reject(err)
        })
    })
  },
  requestCoupone: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(EVENT_REQUEST)

      axios
        .put('/purchase/coupon/order', {
          authentication: {
            memberTp: payload.memberTp
          },
          purchase: {
            orders: {
              purchaseTp: payload.purchaseTp ? payload.purchaseTp : '',
              coupon: {
                couponNo: payload.couponNo
              }
            }
          }
        })
        .then((resp) => {
          resolve(resp)
        })
        .catch((err) => {
          commit(EVENT_FAILURE, err)
          reject(err)
        })
    })
  },
  requestDiscounte: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      commit(EVENT_REQUEST)

      axios
        .put('/discount/coupon/use', {
          discount: {
            discntNo: payload.discntNo
          }
        })
        .then((resp) => {
          resolve(resp)
        })
        .catch((err) => {
          commit(EVENT_FAILURE, err)
          reject(err)
        })
    })
  },
  setCookie({ commit }, payload) {
    console.log(commit)
    const date = new Date()
    date.setTime(date.getTime() + payload.exp * 60 * 1000)
    document.cookie =
      payload.name +
      '=' +
      JSON.stringify(payload.value) +
      ';expires=' +
      date.toUTCString() +
      ';path=/'
  },
  getCookie({ commit }, payload) {
    console.log(commit)
    var value = document.cookie.match('(^|;) ?' + payload + '=([^;]*)(;|$)')
    return value ? JSON.parse(value[2]) : null
  },

  [EVENT_GET_LIST]: ({ commit }, { search, page, pageRow, eventCd }) => {
    return new Promise((resolve, reject) => {
      commit(EVENT_REQUEST)

      axios
        .get(`customer/event/list`, {
          params: {
            searchTp: search,
            pageNo: page,
            pageRow,
            eventCd
          }
        })
        .then((resp) => {
          commit(EVENT_SUCCESS, {
            events: resp.data.result?.eventList || [],
            meta: resp.data.page
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(EVENT_FAILURE, err)
          reject(err)
        })
    })
  },
  [ONE_TOUCH_COUPON]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(EVENT_REQUEST)

      axios
        .post(`/discount/coupon/download`)
        .then((resp) => {
          commit(EVENT_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(EVENT_FAILURE, err)
          reject(err)
        })
    })
  },
  [FETCH_EVENT_POINT_RANK]: ({ commit }, eventId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event/${eventId}/university/rank`)
        .then((resp) => {
          commit('SET_RANK_LIST', resp.data.result.rank) // 데이터 저장
          resolve(resp)
        })
        .catch((err) => {
          commit('EVENT_FAILURE', err) // 요청 실패
          reject(err)
        })
    })
  },

  [FETCH_EVENT_POINT_UNIVERSITY]: ({ commit }, { eventId, univCode }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/event/${eventId}/university/${univCode}`)
        .then((resp) => {
          commit('SET_USER_UNIV_INFO', resp.data.result.info) // 데이터 저장
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [CLAIM_CONTENT]: ({ commit }, { type, code }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/claim/${type}`, { code })
        .then((resp) => {
          commit(CLEAR_CLAIM_CODE)
          resolve(resp)
        })
        .catch((err) => {
          commit(CLEAR_CLAIM_CODE)
          reject(err)
        })
    })
  }
}

const mutations = {
  beforeRouteName(state, payload) {
    state.beforeRouteName = payload
  },
  fetchPublishList(state, payload) {
    state.publishList = payload
    state.publishList4Pages = payload
  },
  fetchPublishPageInfo(state, payload) {
    state.publishInfo = payload
  },
  fetchUnicols(state, { page, list, search }) {
    if (search === state.unicolsSearch && page.pageNo > 1) {
      state.unicolsInfo = page
      state.unicolsList = [...state.unicolsList, ...list]
    } else {
      state.unicolsSearch = search
      state.unicolsInfo = page
      state.unicolsList = list
    }
  },
  fetchPublish(state, { page, list, search }) {
    if (search === state.publishSearch && page.pageNo > 1) {
      state.publishInfo = page
      state.publishList = [...state.publishList, ...list]
    } else {
      state.publishSearch = search
      state.publishInfo = page
      state.publishList = list
    }
    state.publishList4Pages = list
  },
  fetchDepartments(state, list) {
    state.departmentsList = list
  },
  resetPublish(state) {
    state.publishSearch = ''
    state.publishInfo = {}
    state.publishList = []
    state.publishList4Pages = []
  },
  resetUnicols(state) {
    state.unicolsSearch = ''
    state.unicolsInfo = {}
    state.unicolsList = []
  },
  resetDepartments(state) {
    state.departmentsList = []
  },
  // fetchUnicolsPageInfo(state, payload) {
  //   state.unicolsInfo = payload
  // },
  [EVENT_REQUEST]: (state) => {
    state.isLoading = true
  },
  [EVENT_SUCCESS]: (state, { events, meta }) => {
    state.isLoading = false

    if (events) state.events = events
    if (meta) state.meta = meta
  },
  [EVENT_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  closeTopBanner(state) {
    state.isTopBanner = false
  },
  [SET_RANK_LIST]: (state, rank) => {
    state.eventRankList = rank
  },
  [SET_USER_UNIV_INFO]: (state, info) => {
    state.eventUserUnivInfo = info
  },
  [PREPARE_CLAIM_CODE]: (state, code) => {
    state.preparedClaimCode = code
    sessionStorage.setItem('claim_code', code)
  },
  [CLEAR_CLAIM_CODE]: (state) => {
    state.preparedClaimCode = null
    sessionStorage.removeItem('claim_code')
  },
  [PREPARE_CLAIM_TYPE]: (state, type) => {
    state.preparedClaimType = type
    sessionStorage.setItem('claim_type', type)
  },
  [CLEAR_CLAIM_TYPE]: (state) => {
    state.preparedClaimType = null
    sessionStorage.removeItem('claim_type')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
